<template>
    <div class="opt-in-banner relative w-full max-w-auto mt-10 py-8 md:py-12 px-4 md:px-12">
        <div class="image-section absolute left-0 bottom-0 top-0 w-full h-64 -z-10">
            <img src="/images/event_sample1.png"
                alt="Guitar lessons"
                class="absolute left">
            <img src="/images/event_sample2.png"
                alt="Live coaching"
                class="absolute right">
        </div>
        <ClientOnly>
            <div class="flex flex-col items-center justify-center">
                <form action="https://app.kit.com/forms/7431188/subscriptions"
                    class="seva-form formkit-form"
                    method="post"
                    data-sv-form="7431188"
                    data-uid="ac16f99c41"
                    data-format="inline"
                    data-version="5"
                    data-options="{&quot;settings&quot;:{&quot;after_subscribe&quot;:{&quot;action&quot;:&quot;redirect&quot;,&quot;success_message&quot;:&quot;Success! Now check your email to confirm your subscription.&quot;,&quot;redirect_url&quot;:&quot;https://wellwellwell.io&quot;},&quot;analytics&quot;:{&quot;google&quot;:null,&quot;fathom&quot;:null,&quot;facebook&quot;:null,&quot;segment&quot;:null,&quot;pinterest&quot;:null,&quot;sparkloop&quot;:null,&quot;googletagmanager&quot;:null},&quot;modal&quot;:{&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15},&quot;powered_by&quot;:{&quot;show&quot;:false,&quot;url&quot;:&quot;https://kit.com/features/forms?utm_campaign=poweredby&amp;utm_content=form&amp;utm_medium=referral&amp;utm_source=dynamic&quot;},&quot;recaptcha&quot;:{&quot;enabled&quot;:false},&quot;return_visitor&quot;:{&quot;action&quot;:&quot;hide&quot;,&quot;custom_content&quot;:&quot;&quot;},&quot;slide_in&quot;:{&quot;display_in&quot;:&quot;bottom_right&quot;,&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15},&quot;sticky_bar&quot;:{&quot;display_in&quot;:&quot;top&quot;,&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15}},&quot;version&quot;:&quot;5&quot;}"
                    min-width="400 500 600 700 800"
                    style="background-color: rgb(250, 248, 244); border-radius: 4px;">
                    <div class="formkit-background"
                        style="opacity: 0.2;"></div>
                    <div data-style="minimal">
                        <div class="formkit-header"
                            data-element="header"
                            style="color: rgb(16, 22, 24); font-size: 27px; font-weight: 700;">
                            <h2>Be the first to know.</h2>
                        </div>
                        <div class="formkit-subheader"
                            data-element="subheader"
                            style="color: rgb(16, 22, 24); font-size: 18px;">
                            <p>Each week, the latest experiences on WellWellWell <br>will glide into your inbox.</p>
                        </div>
                        <ul class="formkit-alert formkit-alert-error"
                            data-element="errors"
                            data-group="alert"></ul>
                        <div data-element="fields"
                            data-stacked="false"
                            class="seva-fields formkit-fields">
                            <div class="formkit-field"><input class="formkit-input"
                                    name="email_address"
                                    aria-label="Email address"
                                    placeholder="Email address"
                                    required=""
                                    type="email"
                                    style="color: rgb(0, 0, 0); border-color: rgb(250, 248, 244); border-radius: 4px; font-weight: 400;">
                            </div><button data-element="submit"
                                class="formkit-submit formkit-submit"
                                style="color: rgb(255, 255, 255); background-color: rgb(16, 22, 24); border-radius: 4px; font-weight: 400;">
                                <div class="formkit-spinner">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div><span class="">Sign me up!</span>
                            </button>
                        </div>
                        <div class="formkit-guarantee"
                            data-element="guarantee"
                            style="color: rgb(77, 77, 77); font-size: 13px; font-weight: 400;">
                            <p>No spam here. Unsubscribe at any time.</p>
                        </div>
                    </div>
                </form>
            </div>
        </ClientOnly>
    </div>
</template>

<script setup>
</script>

<style lang="scss" scoped>
.opt-in-banner {
    min-height: 440px;

    .image-section {
        min-height: 380px;
        position: relative;

        .left {
            left: 0;
            bottom: 0;
        }

        .right {
            right: 0;
            top: 0;
        }

        @media (min-width: 968px) {
            position: absolute;
            min-height: 440px;
        }
    }    
}

.formkit-form[data-uid="ac16f99c41"] * {
    box-sizing: border-box;
}

.formkit-form[data-uid="ac16f99c41"] {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.formkit-form[data-uid="ac16f99c41"] legend {
    border: none;
    font-size: inherit;
    margin-bottom: 10px;
    padding: 0;
    position: relative;
    display: table;
}

.formkit-form[data-uid="ac16f99c41"] fieldset {
    border: 0;
    padding: 0.01em 0 0 0;
    margin: 0;
    min-width: 0;
}

.formkit-form[data-uid="ac16f99c41"] body:not(:-moz-handler-blocked) fieldset {
    display: table-cell;
}

.formkit-form[data-uid="ac16f99c41"] h1,
.formkit-form[data-uid="ac16f99c41"] h2,
.formkit-form[data-uid="ac16f99c41"] h3,
.formkit-form[data-uid="ac16f99c41"] h4,
.formkit-form[data-uid="ac16f99c41"] h5,
.formkit-form[data-uid="ac16f99c41"] h6 {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
}

.formkit-form[data-uid="ac16f99c41"] h2 {
    font-size: 1.5em;
    margin: 1em 0;
}

.formkit-form[data-uid="ac16f99c41"] h3 {
    font-size: 1.17em;
    margin: 1em 0;
}

.formkit-form[data-uid="ac16f99c41"] p {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
}

.formkit-form[data-uid="ac16f99c41"] ol:not([template-default]),
.formkit-form[data-uid="ac16f99c41"] ul:not([template-default]),
.formkit-form[data-uid="ac16f99c41"] blockquote:not([template-default]) {
    text-align: left;
}

.formkit-form[data-uid="ac16f99c41"] p:not([template-default]),
.formkit-form[data-uid="ac16f99c41"] hr:not([template-default]),
.formkit-form[data-uid="ac16f99c41"] blockquote:not([template-default]),
.formkit-form[data-uid="ac16f99c41"] ol:not([template-default]),
.formkit-form[data-uid="ac16f99c41"] ul:not([template-default]) {
    color: inherit;
    font-style: initial;
}

.formkit-form[data-uid="ac16f99c41"] .ordered-list,
.formkit-form[data-uid="ac16f99c41"] .unordered-list {
    list-style-position: outside !important;
    padding-left: 1em;
}

.formkit-form[data-uid="ac16f99c41"] .list-item {
    padding-left: 0;
}

.formkit-form[data-uid="ac16f99c41"][data-format="modal"] {
    display: none;
}

.formkit-form[data-uid="ac16f99c41"][data-format="slide in"] {
    display: none;
}

.formkit-form[data-uid="ac16f99c41"][data-format="sticky bar"] {
    display: none;
}

.formkit-sticky-bar .formkit-form[data-uid="ac16f99c41"][data-format="sticky bar"] {
    display: block;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-input,
.formkit-form[data-uid="ac16f99c41"] .formkit-select,
.formkit-form[data-uid="ac16f99c41"] .formkit-checkboxes {
    width: 100%;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-button,
.formkit-form[data-uid="ac16f99c41"] .formkit-submit {
    border: 0;
    border-radius: 5px;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    margin-bottom: 15px;
    overflow: hidden;
    padding: 0;
    position: relative;
    vertical-align: middle;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-button:hover,
.formkit-form[data-uid="ac16f99c41"] .formkit-submit:hover,
.formkit-form[data-uid="ac16f99c41"] .formkit-button:focus,
.formkit-form[data-uid="ac16f99c41"] .formkit-submit:focus {
    outline: none;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-button:hover>span,
.formkit-form[data-uid="ac16f99c41"] .formkit-submit:hover>span,
.formkit-form[data-uid="ac16f99c41"] .formkit-button:focus>span,
.formkit-form[data-uid="ac16f99c41"] .formkit-submit:focus>span {
    background-color: rgba(0, 0, 0, 0.1);
}

.formkit-form[data-uid="ac16f99c41"] .formkit-button>span,
.formkit-form[data-uid="ac16f99c41"] .formkit-submit>span {
    display: block;
    -webkit-transition: all 300ms ease-in-out;
    transition: all 300ms ease-in-out;
    padding: 12px 24px;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-input {
    background: #ffffff;
    font-size: 15px;
    padding: 12px;
    //border: 1px solid #e3e3e3;
    -webkit-flex: 1 0 auto;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    line-height: 1.4;
    margin: 0;
    //-webkit-transition: border-color ease-out 300ms;
    //transition: border-color ease-out 300ms;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-input:focus {
    outline: none;
    border-color: #1677be;
    -webkit-transition: border-color ease 300ms;
    transition: border-color ease 300ms;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-input::-webkit-input-placeholder {
    color: inherit;
    opacity: 0.8;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-input::-moz-placeholder {
    color: inherit;
    opacity: 0.8;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-input:-ms-input-placeholder {
    color: inherit;
    opacity: 0.8;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-input::placeholder {
    color: inherit;
    opacity: 0.8;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="dropdown"] {
    position: relative;
    display: inline-block;
    width: 100%;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="dropdown"]::before {
    content: "";
    top: calc(50% - 2.5px);
    right: 10px;
    position: absolute;
    pointer-events: none;
    // border-color: #4f4f4f transparent transparent transparent;
    // border-style: solid;
    // border-width: 6px 6px 0 6px;
    height: 0;
    width: 0;
    z-index: 999;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="dropdown"] select {
    height: auto;
    width: 100%;
    cursor: pointer;
    color: #333333;
    line-height: 1.4;
    margin-bottom: 0;
    padding: 0 6px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-size: 15px;
    padding: 12px;
    padding-right: 25px;
    //border: 1px solid #e3e3e3;
    background: #ffffff;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="dropdown"] select:focus {
    outline: none;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] {
    text-align: left;
    margin: 0;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] {
    margin-bottom: 10px;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] * {
    cursor: pointer;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"]:last-of-type {
    margin-bottom: 0;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"] {
    display: none;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"]+label::after {
    content: none;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"]:checked+label::after {
    border-color: #ffffff;
    content: "";
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"]:checked+label::before {
    background: #10bf7a;
    border-color: #10bf7a;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] label {
    position: relative;
    display: inline-block;
    padding-left: 28px;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] label::before,
.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] label::after {
    position: absolute;
    content: "";
    display: inline-block;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] label::before {
    height: 16px;
    width: 16px;
    //border: 1px solid #e3e3e3;
    background: #ffffff;
    left: 0px;
    top: 3px;
}

.formkit-form[data-uid="ac16f99c41"] [data-group="checkboxes"] [data-group="checkbox"] label::after {
    height: 4px;
    width: 8px;
    border-left: 2px solid #4d4d4d;
    border-bottom: 2px solid #4d4d4d;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    left: 4px;
    top: 8px;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-alert {
    background: #f9fafb;
    //border: 1px solid #e3e3e3;
    border-radius: 5px;
    -webkit-flex: 1 0 auto;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    list-style: none;
    margin: 25px auto;
    padding: 12px;
    text-align: center;
    width: 100%;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-alert:empty {
    display: none;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-alert-success {
    background: #d3fbeb;
    border-color: #10bf7a;
    color: #0c905c;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-alert-error {
    background: #fde8e2;
    border-color: #f2643b;
    color: #ea4110;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-spinner {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 0px;
    width: 0px;
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 0px;
    overflow: hidden;
    text-align: center;
    -webkit-transition: all 300ms ease-in-out;
    transition: all 300ms ease-in-out;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-spinner>div {
    margin: auto;
    width: 12px;
    height: 12px;
    background-color: #fff;
    opacity: 0.3;
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: formkit-bouncedelay-formkit-form-data-uid-ac16f99c41- 1.4s infinite ease-in-out both;
    animation: formkit-bouncedelay-formkit-form-data-uid-ac16f99c41- 1.4s infinite ease-in-out both;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-spinner>div:nth-child(1) {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-spinner>div:nth-child(2) {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-submit[data-active] .formkit-spinner {
    opacity: 1;
    height: 100%;
    width: 50px;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-submit[data-active] .formkit-spinner~span {
    opacity: 0;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by[data-active="false"] {
    opacity: 0.35;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit-container {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    margin: 10px 0;
    position: relative;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit-container[data-active="false"] {
    opacity: 0.35;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit {
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #ffffff;
    border-radius: 9px;
    color: #3d3d3d;
    cursor: pointer;
    display: block;
    height: 36px;
    margin: 0 auto;
    opacity: 0.95;
    padding: 0;
    -webkit-text-decoration: none;
    text-decoration: none;
    text-indent: 100%;
    -webkit-transition: ease-in-out all 200ms;
    transition: ease-in-out all 200ms;
    white-space: nowrap;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 157px;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='133' height='36' viewBox='0 0 133 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.861 25.5C0.735 25.5 0.651 25.416 0.651 25.29V10.548C0.651 10.422 0.735 10.338 0.861 10.338H6.279C9.072 10.338 10.668 11.451 10.668 13.824C10.668 15.819 9.219 16.932 8.001 17.226C7.707 17.268 7.707 17.625 8.022 17.688C9.912 18.108 11.088 19.116 11.088 21.321C11.088 23.715 9.429 25.5 6.426 25.5H0.861ZM5.397 23.085C6.825 23.085 7.518 22.224 7.518 21.006C7.518 19.683 6.825 18.948 5.397 18.948H4.2V23.085H5.397ZM5.313 16.617C6.51 16.617 7.245 15.945 7.245 14.601C7.245 13.383 6.51 12.753 5.25 12.753H4.2V16.617H5.313ZM17.9758 23.883C17.9758 23.568 17.6608 23.505 17.5348 23.799C17.0308 24.954 16.1698 25.731 14.5528 25.731C12.8728 25.731 12.0958 24.471 12.0958 22.707V14.937C12.0958 14.811 12.1798 14.727 12.3058 14.727H15.2248C15.3508 14.727 15.4348 14.811 15.4348 14.937V21.657C15.4348 22.581 15.7708 23.022 16.4638 23.022C17.1778 23.022 17.6188 22.581 17.6188 21.657V14.937C17.6188 14.811 17.7028 14.727 17.8288 14.727H20.7478C20.8738 14.727 20.9578 14.811 20.9578 14.937V25.29C20.9578 25.416 20.8738 25.5 20.7478 25.5H18.1858C18.0598 25.5 17.9758 25.416 17.9758 25.29V23.883ZM25.6141 25.29C25.6141 25.416 25.5301 25.5 25.4041 25.5H22.4851C22.3591 25.5 22.2751 25.416 22.2751 25.29V14.937C22.2751 14.811 22.3591 14.727 22.4851 14.727H25.4041C25.5301 14.727 25.6141 14.811 25.6141 14.937V25.29ZM23.9131 13.74C22.8001 13.74 22.0441 12.942 22.0441 11.934C22.0441 10.926 22.8001 10.107 23.9131 10.107C25.0051 10.107 25.7611 10.926 25.7611 11.934C25.7611 12.942 25.0051 13.74 23.9131 13.74ZM26.7883 10.548C26.7883 10.422 26.8723 10.338 26.9983 10.338H29.9173C30.0433 10.338 30.1273 10.422 30.1273 10.548V22.056C30.1273 22.749 30.2533 23.085 30.8203 23.085C31.0093 23.085 31.1983 23.043 31.3663 23.001C31.5133 22.959 31.6183 22.959 31.6183 23.127V25.059C31.6183 25.164 31.5763 25.269 31.4923 25.311C30.9673 25.521 30.2953 25.71 29.5813 25.71C27.7123 25.71 26.7883 24.639 26.7883 22.476V10.548ZM32.4237 14.727C32.8227 14.727 32.9277 14.538 32.9697 14.055L33.1167 12.039C33.1167 11.913 33.2217 11.829 33.3477 11.829H35.8887C36.0147 11.829 36.0987 11.913 36.0987 12.039V14.517C36.0987 14.643 36.1827 14.727 36.3087 14.727H38.2827C38.4087 14.727 38.4927 14.811 38.4927 14.937V16.659C38.4927 16.785 38.4087 16.869 38.2827 16.869H36.0777V22.056C36.0777 22.875 36.5397 23.085 37.0647 23.085C37.4847 23.085 37.9467 22.938 38.3247 22.707C38.4717 22.623 38.5767 22.665 38.5767 22.833V24.828C38.5767 24.933 38.5347 25.017 38.4507 25.08C37.8417 25.458 36.9807 25.71 36.0357 25.71C34.2927 25.71 32.7387 24.912 32.7387 22.476V16.869H31.8567C31.7307 16.869 31.6467 16.785 31.6467 16.659V14.937C31.6467 14.811 31.7307 14.727 31.8567 14.727H32.4237ZM51.3808 14.727C51.5068 14.727 51.5908 14.79 51.6118 14.916L52.3888 19.851L52.5778 21.174C52.6198 21.468 52.9558 21.468 52.9768 21.174C53.0398 20.712 53.0818 20.271 53.1658 19.83L53.8798 14.916C53.9008 14.79 53.9848 14.727 54.1108 14.727H56.6728C56.8198 14.727 56.8828 14.811 56.8618 14.958L54.6778 25.311C54.6568 25.437 54.5728 25.5 54.4468 25.5H51.3178C51.1918 25.5 51.1078 25.437 51.0868 25.311L50.1208 20.082L49.8898 18.633C49.8688 18.444 49.6588 18.444 49.6378 18.633L49.4068 20.103L48.5458 25.311C48.5248 25.437 48.4408 25.5 48.3148 25.5H45.2068C45.0808 25.5 44.9968 25.437 44.9758 25.311L42.8128 14.958C42.7918 14.811 42.8548 14.727 43.0018 14.727H45.9628C46.0888 14.727 46.1728 14.79 46.1938 14.916L46.9288 19.83C47.0128 20.271 47.0758 20.754 47.1388 21.195C47.2018 21.51 47.4748 21.531 47.5378 21.195L47.7478 19.872L48.6088 14.916C48.6298 14.79 48.7138 14.727 48.8398 14.727H51.3808ZM61.1582 25.29C61.1582 25.416 61.0742 25.5 60.9482 25.5H58.0292C57.9032 25.5 57.8192 25.416 57.8192 25.29V14.937C57.8192 14.811 57.9032 14.727 58.0292 14.727H60.9482C61.0742 14.727 61.1582 14.811 61.1582 14.937V25.29ZM59.4572 13.74C58.3442 13.74 57.5882 12.942 57.5882 11.934C57.5882 10.926 58.3442 10.107 59.4572 10.107C60.5492 10.107 61.3052 10.926 61.3052 11.934C61.3052 12.942 60.5492 13.74 59.4572 13.74ZM62.8154 14.727C63.2144 14.727 63.3194 14.538 63.3614 14.055L63.5084 12.039C63.5084 11.913 63.6134 11.829 63.7394 11.829H66.2804C66.4064 11.829 66.4904 11.913 66.4904 12.039V14.517C66.4904 14.643 66.5744 14.727 66.7004 14.727H68.6744C68.8004 14.727 68.8844 14.811 68.8844 14.937V16.659C68.8844 16.785 68.8004 16.869 68.6744 16.869H66.4694V22.056C66.4694 22.875 66.9314 23.085 67.4564 23.085C67.8764 23.085 68.3384 22.938 68.7164 22.707C68.8634 22.623 68.9684 22.665 68.9684 22.833V24.828C68.9684 24.933 68.9264 25.017 68.8424 25.08C68.2334 25.458 67.3724 25.71 66.4274 25.71C64.6844 25.71 63.1304 24.912 63.1304 22.476V16.869H62.2484C62.1224 16.869 62.0384 16.785 62.0384 16.659V14.937C62.0384 14.811 62.1224 14.727 62.2484 14.727H62.8154ZM73.4298 16.323C73.4298 16.638 73.7868 16.68 73.9128 16.407C74.3748 15.315 75.1308 14.496 76.6008 14.496C78.2178 14.496 78.9528 15.609 78.9528 17.373V25.29C78.9528 25.416 78.8688 25.5 78.7428 25.5H75.8238C75.6978 25.5 75.6138 25.416 75.6138 25.29V18.633C75.6138 17.709 75.2778 17.268 74.5848 17.268C73.8708 17.268 73.4298 17.709 73.4298 18.633V25.29C73.4298 25.416 73.3458 25.5 73.2198 25.5H70.3008C70.1748 25.5 70.0908 25.416 70.0908 25.29V10.548C70.0908 10.422 70.1748 10.338 70.3008 10.338H73.2198C73.3458 10.338 73.4298 10.422 73.4298 10.548V16.323Z' fill='%231E1E1E'/%3E%3Cpath d='M100.132 16.3203C105.58 17.3761 107.272 22.4211 107.318 27.4961C107.318 27.6101 107.226 27.7041 107.112 27.7041H100.252C100.138 27.7041 100.046 27.6121 100.046 27.5001C100.026 23.5629 99.3877 20.0896 95.4865 19.9396C95.3705 19.9356 95.2725 20.0276 95.2725 20.1456V27.5001C95.2725 27.6141 95.1806 27.7061 95.0666 27.7061H88.206C88.092 27.7061 88 27.6141 88 27.5001V8.75585C88 8.64187 88.092 8.54989 88.206 8.54989H95.0686C95.1826 8.54989 95.2745 8.64187 95.2745 8.75585V15.7764C95.2745 15.8804 95.3585 15.9644 95.4625 15.9644C95.5445 15.9644 95.6185 15.9104 95.6425 15.8324C97.4081 10.0416 100.709 8.58588 106.07 8.55189C106.184 8.55189 106.276 8.64387 106.276 8.75785V15.7604C106.276 15.8744 106.184 15.9664 106.07 15.9664H100.166C100.066 15.9664 99.9856 16.0464 99.9856 16.1464C99.9856 16.2304 100.048 16.3043 100.132 16.3203ZM118.918 20.7095V16.1704C118.918 16.0564 119.01 15.9644 119.124 15.9644H124.173C124.273 15.9644 124.353 15.8844 124.353 15.7844C124.353 15.6985 124.291 15.6245 124.207 15.6085C120.256 14.8246 118.432 12.5511 118.37 8.75585C118.368 8.64387 118.458 8.54989 118.572 8.54989H125.986C126.1 8.54989 126.192 8.64187 126.192 8.75585V11.9532C126.192 12.0672 126.284 12.1592 126.398 12.1592H130.649C130.763 12.1592 130.855 12.2511 130.855 12.3651V15.7624C130.855 15.8764 130.763 15.9684 130.649 15.9684H126.398C126.284 15.9684 126.192 16.0604 126.192 16.1744V19.8356C126.192 21.1294 126.986 21.5553 128.04 21.5553C129.692 21.5553 131.323 20.8114 131.977 20.4735C132.113 20.4035 132.277 20.5015 132.277 20.6555V26.3543C132.277 26.5063 132.193 26.6463 132.059 26.7183C131.413 27.0582 129.418 28 127.136 28C122.435 27.996 118.918 26.0824 118.918 20.7095ZM109.266 27.4981V16.1704C109.266 16.0564 109.358 15.9644 109.472 15.9644H116.334C116.448 15.9644 116.54 16.0564 116.54 16.1704V27.4981C116.54 27.6121 116.448 27.7041 116.334 27.7041H109.472C109.358 27.7021 109.266 27.6101 109.266 27.4981ZM108.876 11.4913C108.876 13.4189 110.238 14.9826 112.853 14.9826C115.469 14.9826 116.83 13.4189 116.83 11.4913C116.83 9.56369 115.471 8 112.853 8C110.238 8 108.876 9.56369 108.876 11.4913Z' fill='%231E1E1E'/%3E%3C/svg%3E");
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit:hover,
.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit:focus {
    background-color: #ffffff;
    -webkit-transform: scale(1.025) perspective(1px);
    -ms-transform: scale(1.025) perspective(1px);
    transform: scale(1.025) perspective(1px);
    opacity: 1;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit[data-variant="dark"],
.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit[data-variant="light"] {
    background-color: transparent;
    border-color: transparent;
    width: 133px;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit[data-variant="light"] {
    color: #ffffff;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='133' height='36' viewBox='0 0 133 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.861 25.5C0.735 25.5 0.651 25.416 0.651 25.29V10.548C0.651 10.422 0.735 10.338 0.861 10.338H6.279C9.072 10.338 10.668 11.451 10.668 13.824C10.668 15.819 9.219 16.932 8.001 17.226C7.707 17.268 7.707 17.625 8.022 17.688C9.912 18.108 11.088 19.116 11.088 21.321C11.088 23.715 9.429 25.5 6.426 25.5H0.861ZM5.397 23.085C6.825 23.085 7.518 22.224 7.518 21.006C7.518 19.683 6.825 18.948 5.397 18.948H4.2V23.085H5.397ZM5.313 16.617C6.51 16.617 7.245 15.945 7.245 14.601C7.245 13.383 6.51 12.753 5.25 12.753H4.2V16.617H5.313ZM17.9758 23.883C17.9758 23.568 17.6608 23.505 17.5348 23.799C17.0308 24.954 16.1698 25.731 14.5528 25.731C12.8728 25.731 12.0958 24.471 12.0958 22.707V14.937C12.0958 14.811 12.1798 14.727 12.3058 14.727H15.2248C15.3508 14.727 15.4348 14.811 15.4348 14.937V21.657C15.4348 22.581 15.7708 23.022 16.4638 23.022C17.1778 23.022 17.6188 22.581 17.6188 21.657V14.937C17.6188 14.811 17.7028 14.727 17.8288 14.727H20.7478C20.8738 14.727 20.9578 14.811 20.9578 14.937V25.29C20.9578 25.416 20.8738 25.5 20.7478 25.5H18.1858C18.0598 25.5 17.9758 25.416 17.9758 25.29V23.883ZM25.6141 25.29C25.6141 25.416 25.5301 25.5 25.4041 25.5H22.4851C22.3591 25.5 22.2751 25.416 22.2751 25.29V14.937C22.2751 14.811 22.3591 14.727 22.4851 14.727H25.4041C25.5301 14.727 25.6141 14.811 25.6141 14.937V25.29ZM23.9131 13.74C22.8001 13.74 22.0441 12.942 22.0441 11.934C22.0441 10.926 22.8001 10.107 23.9131 10.107C25.0051 10.107 25.7611 10.926 25.7611 11.934C25.7611 12.942 25.0051 13.74 23.9131 13.74ZM26.7883 10.548C26.7883 10.422 26.8723 10.338 26.9983 10.338H29.9173C30.0433 10.338 30.1273 10.422 30.1273 10.548V22.056C30.1273 22.749 30.2533 23.085 30.8203 23.085C31.0093 23.085 31.1983 23.043 31.3663 23.001C31.5133 22.959 31.6183 22.959 31.6183 23.127V25.059C31.6183 25.164 31.5763 25.269 31.4923 25.311C30.9673 25.521 30.2953 25.71 29.5813 25.71C27.7123 25.71 26.7883 24.639 26.7883 22.476V10.548ZM32.4237 14.727C32.8227 14.727 32.9277 14.538 32.9697 14.055L33.1167 12.039C33.1167 11.913 33.2217 11.829 33.3477 11.829H35.8887C36.0147 11.829 36.0987 11.913 36.0987 12.039V14.517C36.0987 14.643 36.1827 14.727 36.3087 14.727H38.2827C38.4087 14.727 38.4927 14.811 38.4927 14.937V16.659C38.4927 16.785 38.4087 16.869 38.2827 16.869H36.0777V22.056C36.0777 22.875 36.5397 23.085 37.0647 23.085C37.4847 23.085 37.9467 22.938 38.3247 22.707C38.4717 22.623 38.5767 22.665 38.5767 22.833V24.828C38.5767 24.933 38.5347 25.017 38.4507 25.08C37.8417 25.458 36.9807 25.71 36.0357 25.71C34.2927 25.71 32.7387 24.912 32.7387 22.476V16.869H31.8567C31.7307 16.869 31.6467 16.785 31.6467 16.659V14.937C31.6467 14.811 31.7307 14.727 31.8567 14.727H32.4237ZM51.3808 14.727C51.5068 14.727 51.5908 14.79 51.6118 14.916L52.3888 19.851L52.5778 21.174C52.6198 21.468 52.9558 21.468 52.9768 21.174C53.0398 20.712 53.0818 20.271 53.1658 19.83L53.8798 14.916C53.9008 14.79 53.9848 14.727 54.1108 14.727H56.6728C56.8198 14.727 56.8828 14.811 56.8618 14.958L54.6778 25.311C54.6568 25.437 54.5728 25.5 54.4468 25.5H51.3178C51.1918 25.5 51.1078 25.437 51.0868 25.311L50.1208 20.082L49.8898 18.633C49.8688 18.444 49.6588 18.444 49.6378 18.633L49.4068 20.103L48.5458 25.311C48.5248 25.437 48.4408 25.5 48.3148 25.5H45.2068C45.0808 25.5 44.9968 25.437 44.9758 25.311L42.8128 14.958C42.7918 14.811 42.8548 14.727 43.0018 14.727H45.9628C46.0888 14.727 46.1728 14.79 46.1938 14.916L46.9288 19.83C47.0128 20.271 47.0758 20.754 47.1388 21.195C47.2018 21.51 47.4748 21.531 47.5378 21.195L47.7478 19.872L48.6088 14.916C48.6298 14.79 48.7138 14.727 48.8398 14.727H51.3808ZM61.1582 25.29C61.1582 25.416 61.0742 25.5 60.9482 25.5H58.0292C57.9032 25.5 57.8192 25.416 57.8192 25.29V14.937C57.8192 14.811 57.9032 14.727 58.0292 14.727H60.9482C61.0742 14.727 61.1582 14.811 61.1582 14.937V25.29ZM59.4572 13.74C58.3442 13.74 57.5882 12.942 57.5882 11.934C57.5882 10.926 58.3442 10.107 59.4572 10.107C60.5492 10.107 61.3052 10.926 61.3052 11.934C61.3052 12.942 60.5492 13.74 59.4572 13.74ZM62.8154 14.727C63.2144 14.727 63.3194 14.538 63.3614 14.055L63.5084 12.039C63.5084 11.913 63.6134 11.829 63.7394 11.829H66.2804C66.4064 11.829 66.4904 11.913 66.4904 12.039V14.517C66.4904 14.643 66.5744 14.727 66.7004 14.727H68.6744C68.8004 14.727 68.8844 14.811 68.8844 14.937V16.659C68.8844 16.785 68.8004 16.869 68.6744 16.869H66.4694V22.056C66.4694 22.875 66.9314 23.085 67.4564 23.085C67.8764 23.085 68.3384 22.938 68.7164 22.707C68.8634 22.623 68.9684 22.665 68.9684 22.833V24.828C68.9684 24.933 68.9264 25.017 68.8424 25.08C68.2334 25.458 67.3724 25.71 66.4274 25.71C64.6844 25.71 63.1304 24.912 63.1304 22.476V16.869H62.2484C62.1224 16.869 62.0384 16.785 62.0384 16.659V14.937C62.0384 14.811 62.1224 14.727 62.2484 14.727H62.8154ZM73.4298 16.323C73.4298 16.638 73.7868 16.68 73.9128 16.407C74.3748 15.315 75.1308 14.496 76.6008 14.496C78.2178 14.496 78.9528 15.609 78.9528 17.373V25.29C78.9528 25.416 78.8688 25.5 78.7428 25.5H75.8238C75.6978 25.5 75.6138 25.416 75.6138 25.29V18.633C75.6138 17.709 75.2778 17.268 74.5848 17.268C73.8708 17.268 73.4298 17.709 73.4298 18.633V25.29C73.4298 25.416 73.3458 25.5 73.2198 25.5H70.3008C70.1748 25.5 70.0908 25.416 70.0908 25.29V10.548C70.0908 10.422 70.1748 10.338 70.3008 10.338H73.2198C73.3458 10.338 73.4298 10.422 73.4298 10.548V16.323Z' fill='white'/%3E%3Cpath d='M100.132 16.3203C105.58 17.3761 107.272 22.4211 107.318 27.4961C107.318 27.6101 107.226 27.7041 107.112 27.7041H100.252C100.138 27.7041 100.046 27.6121 100.046 27.5001C100.026 23.5629 99.3877 20.0896 95.4865 19.9396C95.3705 19.9356 95.2725 20.0276 95.2725 20.1456V27.5001C95.2725 27.6141 95.1806 27.7061 95.0666 27.7061H88.206C88.092 27.7061 88 27.6141 88 27.5001V8.75585C88 8.64187 88.092 8.54989 88.206 8.54989H95.0686C95.1826 8.54989 95.2745 8.64187 95.2745 8.75585V15.7764C95.2745 15.8804 95.3585 15.9644 95.4625 15.9644C95.5445 15.9644 95.6185 15.9104 95.6425 15.8324C97.4081 10.0416 100.709 8.58588 106.07 8.55189C106.184 8.55189 106.276 8.64387 106.276 8.75785V15.7604C106.276 15.8744 106.184 15.9664 106.07 15.9664H100.166C100.066 15.9664 99.9856 16.0464 99.9856 16.1464C99.9856 16.2304 100.048 16.3043 100.132 16.3203ZM118.918 20.7095V16.1704C118.918 16.0564 119.01 15.9644 119.124 15.9644H124.173C124.273 15.9644 124.353 15.8844 124.353 15.7844C124.353 15.6985 124.291 15.6245 124.207 15.6085C120.256 14.8246 118.432 12.5511 118.37 8.75585C118.368 8.64387 118.458 8.54989 118.572 8.54989H125.986C126.1 8.54989 126.192 8.64187 126.192 8.75585V11.9532C126.192 12.0672 126.284 12.1592 126.398 12.1592H130.649C130.763 12.1592 130.855 12.2511 130.855 12.3651V15.7624C130.855 15.8764 130.763 15.9684 130.649 15.9684H126.398C126.284 15.9684 126.192 16.0604 126.192 16.1744V19.8356C126.192 21.1294 126.986 21.5553 128.04 21.5553C129.692 21.5553 131.323 20.8114 131.977 20.4735C132.113 20.4035 132.277 20.5015 132.277 20.6555V26.3543C132.277 26.5063 132.193 26.6463 132.059 26.7183C131.413 27.0582 129.418 28 127.136 28C122.435 27.996 118.918 26.0824 118.918 20.7095ZM109.266 27.4981V16.1704C109.266 16.0564 109.358 15.9644 109.472 15.9644H116.334C116.448 15.9644 116.54 16.0564 116.54 16.1704V27.4981C116.54 27.6121 116.448 27.7041 116.334 27.7041H109.472C109.358 27.7021 109.266 27.6101 109.266 27.4981ZM108.876 11.4913C108.876 13.4189 110.238 14.9826 112.853 14.9826C115.469 14.9826 116.83 13.4189 116.83 11.4913C116.83 9.56369 115.471 8 112.853 8C110.238 8 108.876 9.56369 108.876 11.4913Z' fill='white'/%3E%3C/svg%3E");
}

@-webkit-keyframes formkit-bouncedelay-formkit-form-data-uid-ac16f99c41- {

    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
    }

    40% {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes formkit-bouncedelay-formkit-form-data-uid-ac16f99c41- {

    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
    }

    40% {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }
}

.formkit-form[data-uid="ac16f99c41"] blockquote {
    padding: 10px 20px;
    margin: 0 0 20px;
    border-left: 5px solid #e1e1e1;
}

.formkit-form[data-uid="ac16f99c41"] .seva-custom-content {
    padding: 15px;
    font-size: 16px;
    color: #fff;
    mix-blend-mode: difference;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-modal.guard {
    max-width: 420px;
    width: 100%;
}

.formkit-form[data-uid="ac16f99c41"] {
    //border: 1px solid #e3e3e3;
    max-width: 700px;
    position: relative;
    overflow: hidden;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-size: cover;
    background-position: center;
    opacity: 0.3;
}

.formkit-form[data-uid="ac16f99c41"] [data-style="minimal"] {
    padding: 20px;
    width: 100%;
    position: relative;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-header {
    margin: 0 0 27px 0;
    text-align: center;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-subheader {
    margin: 18px 0;
    text-align: center;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-guarantee {
    font-size: 13px;
    margin: 10px 0 15px 0;
    text-align: center;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-guarantee>p {
    margin: 0;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-powered-by-convertkit-container {
    margin-bottom: 0;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-fields {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 25px auto 0 auto;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-field {
    min-width: 220px;
}

.formkit-form[data-uid="ac16f99c41"] .formkit-field,
.formkit-form[data-uid="ac16f99c41"] .formkit-submit {
    margin: 0 0 15px 0;
    -webkit-flex: 1 0 100%;
    -ms-flex: 1 0 100%;
    flex: 1 0 100%;
}

.formkit-form[data-uid="ac16f99c41"][min-width~="600"] [data-style="minimal"] {
    padding: 40px;
}

.formkit-form[data-uid="ac16f99c41"][min-width~="600"] .formkit-fields[data-stacked="false"] {
    margin-left: -5px;
    margin-right: -5px;
}

.formkit-form[data-uid="ac16f99c41"][min-width~="600"] .formkit-fields[data-stacked="false"] .formkit-field,
.formkit-form[data-uid="ac16f99c41"][min-width~="600"] .formkit-fields[data-stacked="false"] .formkit-submit {
    margin: 0 5px 15px 5px;
}

.formkit-form[data-uid="ac16f99c41"][min-width~="600"] .formkit-fields[data-stacked="false"] .formkit-field {
    -webkit-flex: 100 1 auto;
    -ms-flex: 100 1 auto;
    flex: 100 1 auto;
}

.formkit-form[data-uid="ac16f99c41"][min-width~="600"] .formkit-fields[data-stacked="false"] .formkit-submit {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
}
</style>
